import { render } from "./Main.vue?vue&type=template&id=d7b78edc&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=d7b78edc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d7b78edc"

export default script